import { createContext } from 'react';
import { GridRowId } from '@mui/x-data-grid-pro';

type ExternalRowSelection = {
  selectedIds: Set<GridRowId>;
  toggleRow: (id: GridRowId) => void;
  toggleAll: (ids: GridRowId[]) => void;
  unSelectAll: () => void;
  setSelectedIds: (selectedIds: Set<GridRowId>) => void;
};

export const ExternalRowSelectionContext = createContext<ExternalRowSelection>(
  {} as ExternalRowSelection,
);
